/// <amd-module name="Feed/PublishedPackages/PublishedPackagesTab" />
import * as React from "react";

import { VssComponent } from "VSS/Platform/Layout";
import { BuildPackage } from "Feed/Common/Contracts/Feed";

interface IPublishedPackagesTabLauncherProps {
    packages: BuildPackage[];
}

export class PublishedPackagesTab extends VssComponent<IPublishedPackagesTabLauncherProps> {
    constructor(props: IPublishedPackagesTabLauncherProps) {
        super(props);
    }

    public render() {
        return <div>TODO {this.props.packages.length}</div>;
    }
}
